const middleware = {}

middleware['canAdmin'] = require('../../../middleware/canAdmin.js')
middleware['canAdmin'] = middleware['canAdmin'].default || middleware['canAdmin']

middleware['canAgent'] = require('../../../middleware/canAgent.js')
middleware['canAgent'] = middleware['canAgent'].default || middleware['canAgent']

middleware['canHr'] = require('../../../middleware/canHr.js')
middleware['canHr'] = middleware['canHr'].default || middleware['canHr']

middleware['canSu'] = require('../../../middleware/canSu.js')
middleware['canSu'] = middleware['canSu'].default || middleware['canSu']

middleware['home'] = require('../../../middleware/home.js')
middleware['home'] = middleware['home'].default || middleware['home']

middleware['isAdmin'] = require('../../../middleware/isAdmin.js')
middleware['isAdmin'] = middleware['isAdmin'].default || middleware['isAdmin']

middleware['isAgent'] = require('../../../middleware/isAgent.js')
middleware['isAgent'] = middleware['isAgent'].default || middleware['isAgent']

middleware['isFullserve'] = require('../../../middleware/isFullserve.js')
middleware['isFullserve'] = middleware['isFullserve'].default || middleware['isFullserve']

middleware['isFullservePlus'] = require('../../../middleware/isFullservePlus.js')
middleware['isFullservePlus'] = middleware['isFullservePlus'].default || middleware['isFullservePlus']

middleware['isHr'] = require('../../../middleware/isHr.js')
middleware['isHr'] = middleware['isHr'].default || middleware['isHr']

middleware['isLoggedIn'] = require('../../../middleware/isLoggedIn.js')
middleware['isLoggedIn'] = middleware['isLoggedIn'].default || middleware['isLoggedIn']

middleware['isLoggedOut'] = require('../../../middleware/isLoggedOut.js')
middleware['isLoggedOut'] = middleware['isLoggedOut'].default || middleware['isLoggedOut']

middleware['isSelfserve'] = require('../../../middleware/isSelfserve.js')
middleware['isSelfserve'] = middleware['isSelfserve'].default || middleware['isSelfserve']

middleware['isServer'] = require('../../../middleware/isServer.js')
middleware['isServer'] = middleware['isServer'].default || middleware['isServer']

middleware['isSu'] = require('../../../middleware/isSu.js')
middleware['isSu'] = middleware['isSu'].default || middleware['isSu']

middleware['maintainQuery'] = require('../../../middleware/maintainQuery.js')
middleware['maintainQuery'] = middleware['maintainQuery'].default || middleware['maintainQuery']

export default middleware
